"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var FormFieldWrapper = /** @class */ (function (_super) {
    __extends(FormFieldWrapper, _super);
    function FormFieldWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormFieldWrapper.prototype.findControl = function () {
        return this.find('.awsui-form-field-control');
    };
    FormFieldWrapper.prototype.findLabel = function () {
        return this.find('.awsui-form-field-label');
    };
    FormFieldWrapper.prototype.findHint = function () {
        return this.find('.awsui-form-field-hint');
    };
    FormFieldWrapper.prototype.findError = function () {
        return this.find('[awsui-form-field-region="errorText"]');
    };
    FormFieldWrapper.prototype.findDescription = function () {
        return this.find('.awsui-form-field-description');
    };
    FormFieldWrapper.prototype.findSecondaryControl = function () {
        return this.find('.awsui-form-field-secondary-control');
    };
    return FormFieldWrapper;
}(dom_1.ComponentWrapper));
exports.default = FormFieldWrapper;
//# sourceMappingURL=awsui-form-field.js.map